export default {
  namespaced: true,
  icons_info: {
    interphone : 'Interfon',
    camera: 'Cámara',
    dmp_zone24h: 'Zona 24h',
    dmp_area: 'Área',
    dmp_output: 'Dispositivo de salida',
    dmp_zone: 'Zona',
    button: 'Botón',
    density_device: 'Dispositivo de neblina',
    panel: 'Panel',
    camera_ptz: 'Cámara PTZ',
    sensor_default: 'Sensor de temperatura',
    sensor_3: 'Sensor de vibración',
    sensor_10: 'Sensor de humedad',
    sensor_11: 'Contacto seco',
    sensor_13: 'Voltaje',
    input: 'Dispositivo de entrada'
  },
};
